<!-- app-loader.component.html -->
<ng-template #content let-modal>
    <div class="d-flex justify-content-center align-items-center" >
        <div class="whirly-loader"> </div>
    </div>
</ng-template>